module.exports = __webpack_public_path__ + "static/media/Crayfish.2cf5dea7.png";